import { useState, useEffect, useCallback } from 'react';

interface ToastMessage {
  id: number;
  text: string;
  type: 'error' | 'success' | 'info';
}

let toastId = 0;
let addToastFn: ((text: string, type?: 'error' | 'success' | 'info') => void) | null = null;

/** Call from anywhere to show a toast notification */
export function showToast(text: string, type: 'error' | 'success' | 'info' = 'error') {
  addToastFn?.(text, type);
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((text: string, type: 'error' | 'success' | 'info' = 'error') => {
    const id = ++toastId;
    setToasts(prev => [...prev.slice(-4), { id, text, type }]); // Max 5 toasts
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 5000);
  }, []);

  useEffect(() => {
    addToastFn = addToast;
    return () => { addToastFn = null; };
  }, [addToast]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <span className="toast-icon">{t.type === 'error' ? '!' : t.type === 'success' ? '✓' : 'i'}</span>
          <span className="toast-text">{t.text}</span>
          <button className="toast-close" onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}>×</button>
        </div>
      ))}
    </div>
  );
}
